import { formatDate } from '@/portainer/filters/filters';

import { SilencedAlertRow, SilencedAlertsResponse } from './types';

export function transformToAlertRuleRow(
  silencedAlertsResponse: SilencedAlertsResponse
): Array<SilencedAlertRow> {
  // Flatten the response structure and extract all silenced alerts
  const allSilencedAlerts = silencedAlertsResponse.flatMap(
    (response) => response.Payload || []
  );

  return allSilencedAlerts.map((silencedAlert) => ({
    id: silencedAlert.id,
    startsAt: formatDate(new Date(silencedAlert.startsAt)),
    endsAt: formatDate(new Date(silencedAlert.endsAt)),
    createdBy: silencedAlert.createdBy,
    comment: silencedAlert.comment,
    alertRule:
      silencedAlert.matchers.find((matcher) => matcher.name === 'alertname')
        ?.value || '-',
    status: silencedAlert.status.state,
    canDelete: ['active', 'pending'].includes(silencedAlert.status.state),
  }));
}
